// 获取浏览器信息
export const getBrowerInfo = () => {
  return {
    versions: (function () {
      const u = navigator.userAgent;
      return {
        trident: u.includes('Trident'), // IE内核
        presto: u.includes('Presto'), // opera内核
        webKit: u.includes('AppleWebKit'), // 苹果、谷歌内核
        gecko: u.includes('Gecko') && !u.includes('KHTML'), // 火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
        android: u.includes('Android') || u.includes('Adr'), // android终端
        iPhone: u.includes('iPhone'), // 是否为iPhone或者QQHD浏览器
        iPad: u.includes('iPad'), // 是否iPad
        webApp: !u.includes('Safari'), // 是否web应该程序，没有头部与底部
        weixin: u.includes('MicroMessenger'), // 是否微信 （2015-01-22新增）
        qq: u.match(/\sQQ/i) === ' qq', // 是否QQ
        innerAmap: u.includes('YYApp'), // 是否是在约约app 中，需做兼容，以前使用 amap作为关键字
        dingTalk: u.includes('DingTalk') // 是否在钉钉中
      };
    })(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
  };
};

// 判断是否是Android
export const isAndroid = () => {
  const info = getBrowerInfo();
  if (info.versions.android) {
    return true;
  }
  return false;
};

// 判断是否是ios
export const isIOS = () => {
  const info = getBrowerInfo();
  if (info.versions.ios) {
    return true;
  }
  return false;
};

export const getExtraUrl = () => {
  const obj = {
    action: 'getExtraUrl'
  };
  return new Promise((resolve) => {
    window.AmapApp.bridge.send(obj, function (res) {
      if (res && typeof res === 'string') {
        res = JSON.parse(res);
      }
      resolve(res || {});
    });
  });
};

// 获取app版本
export const getAppVerson = () => {
  return new Promise((resolve) => {
    getExtraUrl().then((res) => {
      if (res && res.div) {
        let verson = res.div;
        if (isAndroid()) {
          verson = verson.replace('ANDH', '');
        }
        if (isIOS()) {
          verson = verson.replace('IOSH', '');
        }
        resolve({ appVersion: verson });
      } else {
        resolve({ appVersion: '' });
      }
    });
  });
};

// 是否在代驾app内
export const isInnerYueyue = () => {
  const ua = navigator.userAgent;
  if (ua.includes('YYApp')) {
    return true;
  }
  return false;
};

export const monitorRequest = (type, data) => {
  const obj = {
    action: 'sendJSTraceData',
    body: {
      type,
      data
    }
  };
  console.log('🍓monitorRequest_obj', obj);
  return new Promise((resolve, reject) => {
    let timer = null;
    if (timer) {
      timer = setTimeout(() => {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject({ msg: '网络超时，请稍后重试' });
      }, timer);
    }

    window.AmapApp.bridge.send(obj, function (res) {
      let content = res && res.content;
      if (content && typeof content === 'string') {
        content = JSON.parse(content);
      }
      if (timer) {
        clearTimeout(timer);
      }
      if (!navigator.onLine) {
        const networkError = {
          code: 9999,
          msg: '网络异常，请检查网络状态后重试'
        };
        resolve(networkError);
      }
      resolve(content);
    });
  });
};
